import { useSearchParams } from "react-router-dom";
import {
  AUTH_ROUTES,
  AUTH_QUERY_PARAMS,
  AUTH_SOURCES,
  LAWYER_ROUTES,
} from "@/shared/constants/paths";

export function useSignInRoute() {
  const [searchParams] = useSearchParams();
  const isFromLawyer = searchParams.get(AUTH_QUERY_PARAMS.FROM) === AUTH_SOURCES.LAWYER;
  const signInRoute = isFromLawyer ? LAWYER_ROUTES.LOGIN : AUTH_ROUTES.SIGN_IN;
  return { isFromLawyer, signInRoute };
}
